import { defineNuxtPlugin, useRuntimeConfig, onNuxtReady } from "#app";
import { watch } from "vue";
import * as Sentry from "@sentry/vue";
import { browserTracingIntegration } from "@sentry/vue";
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  if (!config.public.sentryDsn) {
    return;
  }
  Sentry.init({
    enabled: config.public.env !== "local",
    environment: config.public.env,
    app: nuxtApp.vueApp,
    dsn: config.public.sentryDsn,
    integrations: [
      browserTracingIntegration({
        router: nuxtApp.$router
      })
      // Do not add Replay integration here as it's very heavy.
      // We'll lazy load it on onNuxtReady() instead.
    ],
    // This sets the sample rate to be 1%
    replaysSessionSampleRate: 1e-3,
    // Force replace when an error occurs
    replaysOnErrorSampleRate: 1,
    trackComponents: true,
    tracesSampler: (samplingContext) => {
      let sampleRate = 0.01;
      if (samplingContext.request && samplingContext.request.query_string) {
        const debugParam = samplingContext.request.query_string ? ["debug"][0] : "";
        sampleRate = debugParam.split(",").includes("monitor") ? 1 : sampleRate;
        if (sampleRate === 1) {
          console.log("Enforcing Sentry Performance Monitoring...");
        }
      }
      return sampleRate;
    }
  });
  onNuxtReady(async () => {
    const { replayIntegration } = await import("@sentry/browser");
    Sentry.addIntegration(replayIntegration({
      maskAllText: false,
      // Display texts
      blockAllMedia: false
      // Display images
    }));
  });
  if (nuxtApp.$auth) {
    watch(() => nuxtApp.$auth.user, (user) => {
      if (user) {
        Sentry.setUser({
          id: user.id
        });
      } else {
        Sentry.setUser(null);
      }
    }, { immediate: true });
  }
  return {
    provide: {
      sentry: {
        setContext: Sentry.setContext,
        setTag: Sentry.setTag,
        addBreadcrumb: Sentry.addBreadcrumb,
        captureException: Sentry.captureException,
        captureMessage: Sentry.captureMessage
      }
    }
  };
});
